const ThreediumModelEnum = {
  CameraDesktop: 'Camera Desktop',
  CameraMobile: 'Camera Mobile',
  '18k Yellow Gold': 'Gold Yellow',
  '18k White Gold': 'Gold White',
  '18k Rose Gold': 'Gold Rose',
  'Platinum': 'Gold White',
  OverlayEngraving: 'Engraving',
  OverlayEntry: 'Text',
  SpinSmallHeart: 'Small Heart',
  SpinMiddleHeart: 'Middle Heart',
  FocusReset: 'Camera Start',
  FocusPlate: 'Camera Buckle',
  FocusEngraving: 'Camera Engraving',
  FocusResetMobile: 'Camera Mobile Start',
  FocusPlateMobile: 'Camera Mobile Buckle',
  FocusEngravingMobile: 'Camera Engraving Mobile',
  58229: {
    description: 'full paved',
    parts: ['outside_001', 'outside_claws_001', 'middle_001', 'middle_claws_001', 'inside_001', 'inside_claws_001', 'chain_001'],
  },
  58670: {
    description: 'semi paved',
    parts: ['outside_001', 'middle_001', 'inside_001', 'chain_001', 'middle_claws_001', 'inside_claws_001'],
  },
  58672: {
    description: 'full gold 1',
    parts: ['outside_001', 'middle_001', 'inside_001', 'chain_001'],
  },
  58671: {
    description: 'full gold 2',
    parts: ['outside_001', 'middle_001', 'inside_001', 'chain_001'],
  },
};

const modelEl = document.getElementById('product-3d-model');
const solution3DID = modelEl.dataset.solutionId;
const isMobile = checkDevice() !== 'desktop';

let variantName3d = '18k Yellow Gold';
let initMaterial = ThreediumModelEnum[variantName3d];
let disableActions = false;
let isPlateFocused = false;
let initUrl = document.URL;

const options = {
  solution3DID,
  containerID: 'container3d',
  distID: 'latest',
  projectName: 'Lustrlabs',
  onCameraInteraction: function () {
    if (disableActions) { return; }
    const actionsEl = document.getElementById('actions');
    actionsEl.style.display = 'flex';
    hideIntroButton();
  },
};

const config = {
  camera: isMobile ? ThreediumModelEnum.CameraMobile : ThreediumModelEnum.CameraDesktop,
  parts: {
    materials: {
      initMaterial: ThreediumModelEnum[solution3DID].parts,
    },
  },
};

Unlimited3D.init(options, config, function (error, status) {
  if (error || !status) {
    return;
  }
  model3dLoader.style.display = 'none';
  document.getElementById('engraving-start-button').disabled = false;
});

const toggleMaterial = () => {
  if (disableActions) { return; }
  toggleDisableButtons(true);

  Unlimited3D.enableCameraControls({ enable: false }, () => {
    Unlimited3D.changeMaterial({
      parts: ThreediumModelEnum[solution3DID].parts,
      material: ThreediumModelEnum[variantName3d],
    }, (error, result) => {
      Unlimited3D.enableCameraControls({ enable: true }, () => {
        toggleDisableButtons(false);
      });
    });
  });
};

document.addEventListener('change', function () {
  let currentPageUrl = document.URL;
  let url = new URL(currentPageUrl);
  let variantParam = url.searchParams.get('variant');
  if (variantParam && initUrl !== currentPageUrl) {
    initUrl = currentPageUrl;
    toggleMaterial();
  }
});

const startTransition = (transitionName, transitionDuration) => {
  if (isPlateFocused) {
    resetAndTransition(transitionName, transitionDuration);
    return;
  }

  if (disableActions) { return; }
  toggleDisableButtons(true);

  Unlimited3D.enableCameraControls({ enable: false }, () => {
    Unlimited3D.activateTransition({
      transition: transitionName,
      duration: transitionDuration,
    }, (error, result) => {
      Unlimited3D.enableCameraControls({ enable: true }, () => {
        toggleDisableButtons(false);
        isPlateFocused = transitionName === ThreediumModelEnum.FocusPlate || transitionName === ThreediumModelEnum.FocusPlateMobile;
      });
    });
  });
};

const resetAndTransition = (transitionName, transitionDuration) => {
  if (disableActions) { return; }
  toggleDisableButtons(true);

  Unlimited3D.enableCameraControls({ enable: false }, () => {
    Unlimited3D.activateTransition({
      transition: isMobile ? ThreediumModelEnum.FocusResetMobile : ThreediumModelEnum.FocusReset,
      duration: 1000,
    }, (error, result) => {
      isPlateFocused = false;

      Unlimited3D.activateTransition({
        transition: transitionName,
        duration: transitionDuration,
      }, (error, result) => {
        Unlimited3D.enableCameraControls({ enable: true }, () => {
          toggleDisableButtons(false);
        });
      });
    });
  });
};

const toggleDisableButtons = (newValue) => {
  disableActions = newValue;
  document.getElementById('spinSmallHeartBtn').disabled = disableActions;
  document.getElementById('spinMiddleHeartBtn').disabled = disableActions;
  document.getElementById('focusPlateBtn').disabled = disableActions;
  document.getElementById('focusResetBtn').disabled = disableActions;
};

const hideIntroButton = () => {
  const introIconEl = document.getElementById('introIcon');
  introIconEl.style.display = 'none';
};

document.getElementById('spinSmallHeartBtn').addEventListener('click', () => {
  startTransition(ThreediumModelEnum.SpinSmallHeart, 1500);
});

document.getElementById('spinMiddleHeartBtn').addEventListener('click', () => {
  startTransition(ThreediumModelEnum.SpinMiddleHeart, 2000);
});

document.getElementById('focusPlateBtn').addEventListener('click', () => {
  startTransition(isMobile ? ThreediumModelEnum.FocusPlateMobile : ThreediumModelEnum.FocusPlate, 1000);
});

document.getElementById('focusResetBtn').addEventListener('click', () => {
  startTransition(isMobile ? ThreediumModelEnum.FocusResetMobile : ThreediumModelEnum.FocusReset, 1000);
});

document.addEventListener('engravingTextChanged', (event) => {
  changeText();
});

document.addEventListener('engravingInProgressChanged', (event) => {
  hideIntroButton();
  handleEngravingInProgressChange();
});

function handleEngravingInProgressChange() {
  if (engravingInProgressObservable.value) {
    Unlimited3D.enableCameraControls({ enable: false }, () => {
      toggleDisableButtons(true);

      Unlimited3D.activateTransition({
        transition: isMobile ? ThreediumModelEnum.FocusEngravingMobile : ThreediumModelEnum.FocusEngraving,
        duration: 1000,
      }, (error, result) => {});
    });
  } else {
    Unlimited3D.enableCameraControls({ enable: true }, () => {
      toggleDisableButtons(false);

      Unlimited3D.activateTransition({
        transition: isMobile ? ThreediumModelEnum.FocusResetMobile : ThreediumModelEnum.FocusReset,
        duration: 1000,
      }, (error, result) => {});
    });
  }
}

function changeText() {
  Unlimited3D.updateOverlay({
    overlay: ThreediumModelEnum.OverlayEngraving,
    overlayEntry: ThreediumModelEnum.OverlayEntry,
    options: {
      text: engravingTextObservable.value,
      fontUrl: 'https://cdn.shopify.com/s/files/1/0865/8776/9166/files/ABCDiatypeMono-Regular.woff2?v=1729769772',
    },
  }, (error, result) => {});
}
